import { Language } from '../translations'

export const educationTranslations: Record<string, Record<Language, string>> = {
  institution: {
    en: 'Institution',
    fi: 'Oppilaitos'
  },
  degree: {
    en: 'Degree',
    fi: 'Tutkinto'
  },
  fieldOfStudy: {
    en: 'Field of Study',
    fi: 'Opintoala'
  },
  addEducation: {
    en: 'Add Education',
    fi: 'Lisää koulutus'
  },
  editEducation: {
    en: 'Edit Education',
    fi: 'Muokkaa koulutusta'
  },
  educationAddedSuccess: {
    en: 'Education added successfully',
    fi: 'Koulutus lisätty onnistuneesti'
  },
  educationUpdatedSuccess: {
    en: 'Education updated successfully',
    fi: 'Koulutus päivitetty onnistuneesti'
  },
  educationDeletedSuccess: {
    en: 'Education deleted successfully',
    fi: 'Koulutus poistettu onnistuneesti'
  },
  confirmDeleteEducation: { en: "Are you sure you want to delete this education?", fi: "Haluatko varmasti poistaa tämän koulutuksen?" },
  noEducationEntries: {
    en: 'No education entries',
    fi: 'Ei koulutustietoja'
  },
};